import {
  Accordion,
  AccordionSummary,
  Autocomplete,
  Box,
  Chip,
  CircularProgress,
  IconButton,
  TextField,
} from "@mui/material";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FilterListIcon from "@mui/icons-material/FilterList";

type RedirectingComponentProps = {
  linkText: string;
  linkTo: string;
  badgeCount: number | null;
  // Όσο τρέχει το count -> spinner αντί για chip.
  badgeLoading?: boolean;
  filters: {
    filterName: string;
    filterLabel: string;
    filterOptions: {
      value: number | string;
      label: string;
    }[];
  }[];
};

function RedirectingComponent(props: RedirectingComponentProps) {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const chamberPage = props.linkTo.split("/")[2];
  localStorage.removeItem(`searchFilters-${chamberPage}`);
  return (
    <Accordion
      elevation={0}
      expanded={expanded}
      sx={{ "&:before": { display: "none" } }}
    >
      <AccordionSummary
        sx={{
          ".MuiAccordionSummary-expandIconWrapper": { display: "none" },
          "& .MuiAccordionSummary-content": { margin: 0 },
          px: 0,
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            flexWrap: { xs: "wrap", sm: "nowrap" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexShrink: 0,
              ml: "auto",
              order: { xs: 1, sm: 2 },
            }}
          >
            {props.badgeLoading ? (
              <CircularProgress size={16} color="warning" />
            ) : (
              props.badgeCount != null && (
                <Chip
                  label={`${props.badgeCount}`}
                  color="warning"
                  size="small"
                />
              )
            )}
            {props.filters.length > 0 && (
              <IconButton
                onClick={() => setExpanded((v) => !v)}
                color="primary"
                size="small"
              >
                <FilterListIcon />
              </IconButton>
            )}

          </Box>

          <Box
            sx={{
              minWidth: 0,
              flexGrow: 1,
              order: { xs: 2, sm: 1 },
              width: { xs: "100%", sm: "auto" },
            }}
          >
            <Link
              to={props.linkTo}
              style={{
                textDecoration: "none",
                display: "block",
                whiteSpace: "normal",
                overflowWrap: "anywhere",
                wordBreak: "break-word",
              }}
            >
              {props.linkText}
            </Link>
          </Box>
        </Box>
      </AccordionSummary>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
          gap: "1em",
        }}
      >
        {props.filters.map((filter) => (
          <Autocomplete
            options={filter.filterOptions}
            getOptionLabel={(option) => option.label}
            onChange={(_, option) => {
              if (option) {
                localStorage.setItem(
                  `searchFilters-${chamberPage}`,
                  JSON.stringify({ [filter.filterName]: option.value }),
                );
                navigate(props.linkTo);
              }
            }}
            renderInput={(params) => (
              <TextField {...params} label={filter.filterLabel} />
            )}
          />
        ))}
      </Box>
    </Accordion>
  );
}

export default RedirectingComponent;
